module.exports = __webpack_public_path__ + "media/scanBaseC2.95bd8a3d.mp3";